import { V1ExpertiseAndResources } from "src/pages/reports/fsci/v1/types";

export const meta: Record<V1ExpertiseAndResources, Opportunity> = {
    bestPracticeOrientation: {
        title: "Best Practice Orientation",
        prologue:
            "Keeping up with best practices in teaching is prioritized and resources for doing so can be identified.",
    },
    classroomManagement: {
        title: "Classroom Management",
        prologue: "The classroom is orderly, and teachers are organized and consistent with discipline.",
    },
    engagedLearning: {
        title: "Engaged Learning",
        prologue:
            "Students engage in activities that nurture critical thinking, evaluating information, and problem solving.",
    },
    qualifiedStaff: {
        title: "Qualified Staff",
        prologue:
            "New teacher hires are credentialed (educationally and licensed/certified) and have classroom experience.",
    },
    resourceConstraint: {
        title: "Resource Constraints",
        prologue:
            "The school has financial resources to operate effectively; or a belief is held that the school could be more effective if not for fiscal constraints, and the school lacks the resources needed to make changes in the school.",
        extra: "* A high score indicates that respondents generally disagreed that additional resources would improve administrative or operational effectiveness and agreed that they have sufficient resources to implement necessary changes.",
    },
    resourcePlanning: {
        title: "Resource Planning",
        prologue:
            "A strategic financial plan and master facilities plan is in place, and financial planning is a strength of the board.",
    },
    resources: {
        title: "Resources",
        prologue:
            "Materials and resources for teaching, including technology, are sufficient, and the school building is in good physical condition.",
    },
    responsivenessToSpecialNeeds: {
        title: "Responsiveness to Special Needs",
        prologue:
            "Teaching staff works together to serve students with special needs, aided by processes for identifying and responding to those needs.",
    },
};
